document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const triggerPoint = window.innerHeight * 0.6;

  function handleScroll() {
    if (window.scrollY > triggerPoint) {
      header.classList.add('header-visible');
    } else {
      header.classList.remove('header-visible');
    }
  }

  window.addEventListener('scroll', handleScroll);
  handleScroll();
});
